import { withTranslate } from "@pathwright/ui/src/components/"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import AdaptedSignedInContainer from "@pathwright/web/src/modules/auth/AdaptedSignedInContainer"
import {
  ENROLLMENT_ROLE_STUDENT,
  ROLE_LABELS,
  ROLE_TYPE_OFFERING
} from "@pathwright/web/src/modules/invitation/constants"
import useSpaceHasFeature from "@pathwright/web/src/modules/lib/useSpaceHasFeature"
import { useOrderFulfillment } from "@pathwright/web/src/modules/order/OrderStripeCheckoutForm"
import { withUserCommunity } from "@pathwright/web/src/modules/user/UserCommunityContext"
import ConnectStores from "lib/core/store/components/ConnectStores"
import { useEffect, useState } from "react"
import {
  REGISTER_STATE_PAYMENT,
  REGISTER_STATE_REGISTERABLE,
  REGISTER_STATE_REGISTERED,
  REGISTER_STATE_SUBSCRIBE,
  REGISTER_STATE_UNUSABLE_SUBSCRIPTION
} from "../constants"
import OrderRegistrationButton from "./OrderRegistrationButton"

const tPrefix = "auth.signed_in_footer"

const SignedInFooter = function ({
  continueAction: continueActionProp,
  getContinueAction,
  is_registering,
  registration_loading,
  t
}) {
  const [continueAction, setContinueAction] = useState({})
  const { onContinue, continuePrompt } = continueAction
  const handleOrderFulfillment = useOrderFulfillment()
  const hasAuthPw3 = useSpaceHasFeature("auth__platform")

  // basically poll for continue prompt based on next register state
  useEffect(() => {
    let interval = null
    if (!Object.keys(continueAction).length) {
      interval = setInterval(() => setContinueAction(getContinueAction()), 200)
    } else {
      clearInterval(interval)
    }

    return () => clearInterval(interval)
  }, [continueAction, registration_loading])

  useEffect(() => {
    setContinueAction(continueActionProp)
  }, [continueActionProp.continuePrompt])

  return (
    <div
      className="SignedInFooter"
      style={{ textAlign: "center", padding: "0 20px 20px" }}
    >
      {hasAuthPw3 && <AdaptedSignedInContainer size="lg" />}
      {continuePrompt && !registration_loading ? (
        <OrderRegistrationButton
          submitLabel={continuePrompt}
          onOrderFulfilled={handleOrderFulfillment}
        >
          <SubmitButton
            brand
            styleType="primary"
            onClick={() => onContinue()}
            submitting={is_registering}
          >
            {continuePrompt}
            {continuePrompt === t(`${tPrefix}.continue`) && (
              <>
                {" "}
                <Pathicon icon="arrow-right" />
              </>
            )}
          </SubmitButton>
        </OrderRegistrationButton>
      ) : null}
    </div>
  )
}

SignedInFooter.displayName = "SignedInFooter"

const mapStateToProps = function (state, ownProps) {
  const { t } = ownProps

  const {
    offering,
    invitation,
    registration,
    resource,
    is_registering,
    registration_loading
  } = state.registerStore.state
  const { setRegisterState } = state.registerStore.action
  const { accessURL, getNextRegisterState } = state.registerStore.request

  const useGroupSubscriptionIds = ownProps.communityGroupSubscriptions
    .filter((cgs) =>
      offering.include_with_products.includes(cgs.price.product.id)
    )
    .map((cgs) => cgs.id)

  const getContinueAction = () => {
    let continuePrompt
    let onContinue
    const nextRegisterState = getNextRegisterState({
      includedInGroupSubscription: useGroupSubscriptionIds
    })

    switch (nextRegisterState) {
      case REGISTER_STATE_REGISTERED:
        // "Continue Learning" - not always appropriate. Need to scope to user role.
        continuePrompt = t("resource.offering_form.continue")
        onContinue = () => {
          // Navigate to the path since already registered
          window.App.navigate(accessURL(resource, registration))
        }
        break
      case REGISTER_STATE_PAYMENT:
      case REGISTER_STATE_UNUSABLE_SUBSCRIPTION:
        continuePrompt = t(`${tPrefix}.continue`)
        onContinue = setRegisterState
        break
      case REGISTER_STATE_SUBSCRIBE:
        continuePrompt = t("resource.offering_form.subscribe")
        onContinue = setRegisterState
        break
      case REGISTER_STATE_REGISTERABLE:
        continuePrompt = t(`${tPrefix}.register`)
        onContinue = () => console.warn("Attempted legacy register action") // noop
        if (
          invitation != null &&
          invitation.role &&
          invitation.role !== ENROLLMENT_ROLE_STUDENT
        ) {
          const role = t(
            `${tPrefix}.offering_role_labels.${ROLE_LABELS[ROLE_TYPE_OFFERING][
              invitation.role
            ]
              .split(" ")
              .join("_")}`
          )
          continuePrompt = `${continuePrompt} ${t(
            `${tPrefix}.as`
          )} ${role.toLowerCase()}`
        }
        break
    }

    return {
      continuePrompt,
      onContinue
    }
  }

  const continueAction = getContinueAction()

  return _.assign(
    {},
    {
      getContinueAction,
      continueAction,
      is_registering,
      registration_loading,
      getNextRegisterState
    },
    ownProps
  )
}

const stores = [
  {
    store: "register",
    watch: ["is_registering", "registration_loading", "registration"]
  },
  { store: "resource", watch: false }
]

export default withUserCommunity(
  withTranslate(ConnectStores(SignedInFooter, stores, {}, mapStateToProps))
)
